import { gql } from 'apollo-angular';

const UPDATE_USER_ORG_ACCESS = gql`
  mutation updateAssignedOrganizations(
    $userId: Long!
    $allOrgsAssigned: Boolean!
    $organizations: [Long]!
  ) {
    updateAssignedOrganizations(
      updateAssignedOrganizationsRequest: {
        userId: $userId
        assignedOrganizations: {
          allOrgsAssigned: $allOrgsAssigned
          organizations: $organizations
        }
      }
    ) {
      id
      assignedOrgs {
        organizations {
          id
        }
        allOrgsAssigned
      }
    }
  }
`;

export default UPDATE_USER_ORG_ACCESS;
